<template>
  <h1>InputMultipleChoice</h1>

  <div class="row">
    <input-multiple-choice v-model="current" :choices="choices" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>
  </div>
</template>

<script>
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import InputMultipleChoice from './InputMultipleChoice';
import { pickRandom } from '@/utils/arrayUtil';

export default {
  name: 'InputMultipleChoiceDev',
  components: { InputMultipleChoice },
  extends: DevComponentContainer,
  data() {
    return {
      current: null,
      choices: [
        { value: '1', label: '0' },
        { value: '2', label: '1' },
        { value: '3', label: '2' },
        { value: '4', label: '3' },
        { value: '5', label: '3+' },
      ],
    };
  },
  computed: {
    hasValue() {
      return this.current !== null && this.current !== 0;
    },
  },
  methods: {
    randomizeValue() {
      this.current = pickRandom(this.choices).value;
    },
  },
};
</script>
